/**
 * 두 개의 오브젝트를 비교하여 바뀐 키, 값 추출
 * @param obj1 바뀐 오브젝트
 * @param obj2 이전 오브젝트
 * @returns
 */
export const compareObjects = <T extends object>(obj1: T, obj2: T): Partial<T> => {
  const changedEntries = Object.keys(obj1).reduce((acc, key) => {
    const newValue = obj1[key as keyof T];
    const oldValue = obj2[key as keyof T];

    if (oldValue !== newValue) {
      acc[key as keyof T] = newValue; // string 변환 불필요, Partial<T>로 반환
    }
    return acc;
  }, {} as Partial<T>);

  return changedEntries;
};

export const compareArrays = <T extends object>(arr1: T[], arr2: T[]): Partial<T>[] => {
  return arr1.map((item, index) => {
    const comparedItem = compareObjects(item, arr2[index]);
    return comparedItem;
  });
};
